import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Flex, UiText } from '@shared/ui';

import cls from './Header.module.css';

interface ICommentsHeaderProps {
    className?: string;
    positionName?: string;
}
export const CommentsHeader = ({ className, positionName = '' }: ICommentsHeaderProps) => {
    const { t } = useTranslation();

    return (
        <Flex
            direction="column"
            align="start"
            gap={8}
            as="header"
            className={cn(cls.Header, className)}
        >
            <UiText variant="heading" weight="semibold" tag="h2">
                {t('Comments.Header.Title')}
            </UiText>
            <UiText variant="plain" tag="h3" data-value={positionName}>
                {positionName}
            </UiText>
        </Flex>
    );
};
